﻿import AttachmentType from "../enums/AttachmentType";
import VehicleType from "../enums/VehicleType";
import {InstallationByHostData, ResidencyUses} from "../index";
import RequiredDriverProperties from "../installations/RequiredDriverProperties";
import RequiredResidencyProperties from "../installations/RequiredResidencyProperties";
import RequiredVehicleProperties from "../installations/RequiredVehicleProperties";

export function getRequiredDriverProperties(installationData: InstallationByHostData): RequiredDriverProperties {
	return installationData.configuration.requiredEntityProperties.driver;
}

export function getHiddenDriverProperties(installationData: InstallationByHostData): RequiredDriverProperties {
	return installationData.configuration.hiddenEntityProperties.driver;
}

export function getRequiredDriverAttachmentTypes(installationData: InstallationByHostData): AttachmentType[] {
	return installationData.configuration.requiredAttachmentTypes.driver;
}

export function getRequiredResidencyProperties(installationData: InstallationByHostData, uses: ResidencyUses): RequiredResidencyProperties {
	return installationData.configuration.requiredEntityProperties.residency[ResidencyUses[uses]];
}

export function getHiddenResidencyProperties(installationData: InstallationByHostData, uses: ResidencyUses): RequiredResidencyProperties {
	return installationData.configuration.hiddenEntityProperties.residency[ResidencyUses[uses]];
}

export function getRequiredResidencyAttachmentTypes(installationData: InstallationByHostData, uses: ResidencyUses): AttachmentType[] {
	return installationData.configuration.requiredAttachmentTypes.residency[ResidencyUses[uses]];
}

export function getRequiredVehicleProperties(installationData: InstallationByHostData, type: VehicleType): RequiredVehicleProperties {
	return installationData.configuration.requiredEntityProperties.vehicle[VehicleType[type]];
}

export function getHiddenVehicleProperties(installationData: InstallationByHostData, type: VehicleType): RequiredVehicleProperties {
	return installationData.configuration.hiddenEntityProperties.vehicle[VehicleType[type]];
}

export function getRequiredVehicleAttachmentTypes(installationData: InstallationByHostData, type: VehicleType): AttachmentType[] {
	return installationData.configuration.requiredAttachmentTypes.vehicle[VehicleType[type]];
}
